<template>
  <div  style="display: flex; align-items: center; height: 100vh; background: #2f3437!important;">
    <div v-if="habits.length > 0" class="embed-view">
      <div style="padding: 10px;">
        <HabitItemElement
          v-for="(habit, index) in sortHabits" :key="index"
          :isCheckObject="{ isDone: habit.status }"
          :succesRate="habit.stats"
          :habit="habit"
          :checkEvent="click"
          :index="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HabitItemElement from '../HabitsDashboard/components/HabitItemElement.vue';

const axios = require('axios').default;

export default {
  components: { HabitItemElement },
  data() {
    return {
      habits: [],
    };
  },
  computed: {
    sortHabits() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.habits.sort((a, b) => a.time - b.time);
    },
  },
  methods: {
    async getHabits() {
      const response = await axios({
        method: 'get',
        url: 'https://us-central1-jedeadmin.cloudfunctions.net/app/api/embed?token=bokamix@je2',
      });
      this.habits = response.data;
    },
    async click(habit, index) {
      this.habits[index].status = !this.habits[index].status;
      await axios({
        method: 'get',
        url: `https://us-central1-jedeadmin.cloudfunctions.net/app/api/qr/activity?token=bokamix@je2&key=${habit.firekey}`,
      });
    },
  },
  mounted() {
    this.getHabits();
  },
};
</script>

<style scoped lang="scss">
  .embed-view {
    box-sizing: content-box;
    overflow-y: hidden;
    overflow-x: hidden;
    // background: #2f3437;
  }
</style>
